
import { Component, Emit, Vue, Watch } from 'vue-property-decorator';
// @ts-ignore
import { RecycleScroller } from 'vue-virtual-scroller/dist/vue-virtual-scroller.esm.js'
import Map from '@/ui-components/Map/Map.vue';
import LocationCard from '@/ui-components/LocationCard/LocationCard.vue';
import IButton from '@/ui-components/IButton/IButton.vue';
import { LocationData } from '@/types/locations';
import SelectedLocationsSummary
  from '@/pages/shared/CampaignWizard/components/Locations/components/SelectedLocationsSummary.vue';
import namespaces from '@/store/namespaces';
import { Action, Getter } from 'vuex-class';
import { ClearPendingScrollLocationId, DeselectLocation, SelectLocation, } from '@/store/modules/campaign-wizard/types';
import { LoadLocations } from '@/store/modules/common-module/types';
import { publicRouteNames } from '@/route-names/public';
import LocationFilters from '@/pages/shared/CampaignWizard/components/Locations/components/LocationFilters.vue';
import Pagination from '@/ui-components/Pagination/Pagination.vue';
import Loading from '@/ui-components/LocationCard/components/Loading.vue';
import LocationDetails from '@/ui-components/LocationDetails/LocationDetails.vue';
import { cloneDeep, last } from 'lodash';
import { sortLocationsByPriorityOfAppearance } from '@/utils/locations';
import { fetchCampaignDefaultFrequencyConfigByUserRole } from '@/actions/campaigns/actions';
import { FREQUENCY, FrequencyUserType } from '@/types/campaigns';
import { campaignFrequencies } from '@/statics/campaign-wizard';
import { Nullable } from '@/types/misc';
import { 
  hasValidRouteFilters, 
  filterLocations, 
  validateFilterCriteria,
  queryToFilterCriteria,
} from '@/utils/locations';


@Component({
  components: {
    LocationDetails,
    LocationFilters,
    SelectedLocationsSummary,
    LocationCard,
    Map,
    IButton,
    Pagination,
    Loading,
    RecycleScroller,
  },
})
export default class Locations extends Vue {
  public activeLocationId = '';
  public detailedLocationId = '';
  public loading = false;
  public showMapView = false;
  showGoToTopBtn = false;
  public defaultFrequency!:FREQUENCY;

  @Getter("locations", { namespace: namespaces.CommonModule })
  public locations!: LocationData[];

  @Getter("selectedLocations", { namespace: namespaces.CampaignWizardModule })
  public selectedLocations!: LocationData[];

  @Action("loadLocations", { namespace: namespaces.CommonModule })
  public loadLocations!: LoadLocations;

  @Action("selectLocation", { namespace: namespaces.CampaignWizardModule })
  public selectLocation!: SelectLocation;

  @Action("deselectLocation", { namespace: namespaces.CampaignWizardModule })
  public deselectLocation!: DeselectLocation;

  @Action("clearPendingScrollLocationId", { namespace: namespaces.CampaignWizardModule })
  public clearPendingScrollLocationId!: ClearPendingScrollLocationId;

  @Getter("pendingScrollLocationId", { namespace: namespaces.CampaignWizardModule })
  public pendingScrollLocationId!: Nullable<LocationData['ID']>;

  public filteredLocations: LocationData[] = [];
  public allLocations: Record<string, LocationData> = {};

  get isMobileViewPort() {
    return this.$vuetify.breakpoint.mdAndDown;
  }

  get campaignFrequencies() {
    return campaignFrequencies;
  }

  get filteredLocationsSortedByPriority() {
    return sortLocationsByPriorityOfAppearance(this.filteredLocations);
  }
  set filteredLocationsSortedByPriority(locations) {
    this.filteredLocations = locations;
  }

  public async mounted() {
    this.loading = true;
    const { defaultFrequency } = await fetchCampaignDefaultFrequencyConfigByUserRole(FrequencyUserType.ADVERTISER)
    this.defaultFrequency = defaultFrequency;
    
    // Load all locations first
    const allLocations = await this.loadLocations() || [];
    
    // Store all locations for reference
    this.allLocations = cloneDeep(allLocations).reduce((locations, location) => {
      return {
        ...locations,
        [location.ID]: location
      }
    }, {} as Record<string, LocationData>);

    // Apply filtering based on route parameters (first load)
    this.applyLocationFiltering(allLocations);

    if (this.filteredLocations) {
      const scrollElement = document.getElementById('locations-section');
      scrollElement?.addEventListener('scroll', this.scrollHandler)
    }
    this.loading = false;
  }

  private applyLocationFiltering(allLocations: LocationData[]) {
  try {
    if (hasValidRouteFilters(this.$route.query, allLocations)) {
      const criteria = queryToFilterCriteria(this.$route.query);
      const validatedCriteria = validateFilterCriteria(criteria, allLocations);

      this.filteredLocations = [...filterLocations(allLocations, validatedCriteria)];

    } else {
      this.filteredLocations = [...allLocations];
    }
  } catch (error) {
    console.warn('Error applying route filters:', error);
    this.filteredLocations = [...allLocations];
  }
}

// Also add debugging to the route watcher:
@Watch('$route', { deep: true })
private onRouteChanged() {
  
  // Reapply filters when route changes
  if (this.allLocations && Object.keys(this.allLocations).length > 0) {
    const allLocationsArray = Object.values(this.allLocations);
    this.applyLocationFiltering(allLocationsArray);
  }
}

  public isLocationSelected({ ID }: LocationData) {
    return this.selectedLocations.some(({ ID: locationId }) => locationId === ID);
  }

  public close() {
    this.$router.back()
  }
  public clearFilters() {
    const locationFilters = this.$refs.locationFilters as LocationFilters
    locationFilters.clearFilters();
  }

  scrollHandler() {
    const scrollElement = document.getElementById('locations-section');
    this.showGoToTopBtn = scrollElement!.scrollTop > 100;
  }

  scrollToUp() {
    const scrollTarget = document.getElementById('locations-section');
    scrollTarget?.scrollTo({
      behavior: 'smooth',
      top: 0
    })
  }

  @Emit()
  public nextStep() {
    return true;
  }
public scrollToSelectedLocation(locationId: LocationData['ID']): void {
  const scroller = this.$refs.recycleScroller as RecycleScroller;
  if (!scroller) return;

  const locationIndex = this.filteredLocationsSortedByPriority.findIndex(
    location => location.ID === locationId
  );
  console.log('locationIndex',locationIndex)
  if (locationIndex !== -1) {
    // Use scrollToItem - it's optimized for virtual scrolling
    const itemHeight = this.isMobileViewPort ? 274 : 233;
    const position = locationIndex * itemHeight;
    scroller.scrollToPosition(position);
  }
}
@Watch('pendingScrollLocationId')
async onPendingScrollLocationChange(locationId: Nullable<LocationData['ID']>) {
  if (!locationId) return;
  
  if (this.isMobileViewPort && this.showMapView) {
    console.log('📱 Pending scroll stored for:', locationId);
  } else {
    console.log('🎯 Executing scroll to:', locationId);
    await this.$nextTick();
    await this.scrollToSelectedLocation(locationId);
    this.clearPendingScrollLocationId();
  }
}
@Watch('showMapView')
async onMapViewChange(showMap: boolean) {
  if (this.isMobileViewPort && !showMap && this.pendingScrollLocationId) {
    console.log('📱 Executing pending scroll to:', this.pendingScrollLocationId);
    await this.$nextTick();
    await this.scrollToSelectedLocation(this.pendingScrollLocationId);
    this.clearPendingScrollLocationId();
  }

}
}
